<script>
  import debounce from '@/_legacy/directives/debounce';

  export default {
    name: 'ConductInspectionItemQuestionText',
    directives: {
      debounce,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    methods: {
      valueChanged(value) {
        this.$emit('change', {
          uuid: this.item.uuid,
          response: value,
          responded: !!(value && value.length),
        });
      },
    },
  };
</script>

<template>
    <textarea
      v-debounce="valueChanged"
      class="w-full form-input form-input-bordered py-2"
      rows="1"
      :placeholder="$t('Enter text')"
      :value="item.response"
      :readonly="item.prefillReadOnly === true"
    ></textarea>
</template>
